module.exports = __webpack_public_path__ + "media/images/icon-product/flexible-packaging-6fab17475a9581274e1c8c20c5c880d6.svg";